import template from 'text!./accountPayment.html';

export default {
    template: template,
    bindings: {
        billingInfo: '=',
        billingInfoPromise: '='
    }
};
